module.exports = __webpack_public_path__ + "static/media/canadian.f41f4f02.jpg";